import React, {Component} from 'react';

import PaymentMethodCreditOrDebitCard from './payment-method-credit-or-debit-card'
import PaymentMethodDirectDebitCard from './payment-method-direct-debit-card'

/**
 * Component to display wallet card
 */
class PaymentMethodWalletFields extends Component {
    render() {
        const {wallet, config} = this.props,
            {paymentConfig} = config;

        const pm = paymentConfig.paymentMethods.find(pm => (pm.code === wallet.type));
        if (!pm) {
            return <div data-debug="No PM identified"/>;
        }

        // we have category, and name
        const categoryCode = pm.categoryCode;

        if (categoryCode === 'CC' || categoryCode === 'DC' || categoryCode === 'PD') {
            return (
                <div className="col-12">
                    <PaymentMethodCreditOrDebitCard
                        code={pm.code}
                        description={pm.description}
                        cardHolderName={wallet.cardHolderName}
                        accountNumber={wallet.accountNumber}
                        month={wallet.creditCardExpiryDate && wallet.creditCardExpiryDate.month}
                        year={wallet.creditCardExpiryDate  && wallet.creditCardExpiryDate.year}/>
                </div>
            );
        }

        if (categoryCode === 'DD') {
            return (
                <div className="col-12">
                    <PaymentMethodDirectDebitCard
                        description={pm.description}
                        cardHolderName={wallet.cardHolderName}
                        maskedRoutingNumber={wallet.accountNumber.split('-')[0]}
                        maskedAccountNumber={wallet.accountNumber.split('-')[1]}/>
                </div>
            );
        }

        return (
            <div className="col-12">
                <div data-debug={`Unknown category: ${categoryCode}`}/>
            </div>
        );
    }
}


export default PaymentMethodWalletFields
